import "./modules/init.js";
import "./modules/Video.js";

// styles
import "../scss/bundle.scss";
